import {
  Container,
  styled,
  Box,
} from "@mui/material";
import FigmaModal from "components/modal/FigmaModal";
import { useNavigate } from 'react-router-dom';

const ViewPrivacyPolicyPage = () => {
  const navigate = useNavigate();

  const onClose = () => {
    navigate('/landing');
  }

  return (
    <StyledContainer>
      <Box>
        <FigmaModal type="privacyPolicy" open={true} onClose={onClose} ></FigmaModal>
      </Box>
    </StyledContainer>
  );
};

export default ViewPrivacyPolicyPage;

const StyledContainer = styled(Container)({
  marginBottom: 24,
});

